import axios from 'axios';
import apiBaseUrl from '@/plugins/api/apiBaseUrl';

export default class Indicadores {
  public static get(cod: string): Promise<IndicadorResponse> {
    return Indicadores.instance
      .get<IndicadorResponse>(`parceiros.php`, { params: { ref: cod } })
      .then((response) => response.data);
  }

  public static createDeal(data: {}): Promise<GenericResponse> {
    return Indicadores.instance
      .post<GenericResponse>(`parceiros.php`, data)
      .then((response) => response.data);
  }

  private static instance = axios.create({
    baseURL: apiBaseUrl,
  });
}
